import styled from "styled-components";

export const StyledLanding = styled.section`
	height: 100vh;
`